'use es6';

import createAction from 'flux-actions/createAction';
import { RECEIVED_FORMS, REQUESTED_FORMS, REQUESTED_FORMS_FAILED } from './ActionTypes';
export const requestForms = createAction(REQUESTED_FORMS);
export const receiveForms = createAction(RECEIVED_FORMS, forms => ({
  forms
}));
export const requestedFormsFailed = createAction(REQUESTED_FORMS_FAILED, error => ({
  error
}));